<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.88456 11.9C9.79122 11.9 9.70956 11.8766 9.62789 11.83L7.00289 10.1266L4.37789 11.83C4.21456 11.935 4.00456 11.9233 3.85289 11.8183C3.70122 11.7016 3.63122 11.5033 3.67789 11.3166L4.50622 8.39997L2.04456 6.3233C1.90456 6.20663 1.84622 6.00831 1.90455 5.82164C1.96289 5.64664 2.12622 5.5183 2.31289 5.49497L5.26456 5.28498L6.59456 2.37997C6.67622 2.21664 6.83956 2.11163 7.01456 2.11163C7.20122 2.11163 7.36456 2.21664 7.43456 2.37997L8.76456 5.28498L11.7162 5.49497C11.9029 5.50663 12.0662 5.63497 12.1246 5.82164C12.1829 5.99664 12.1246 6.19496 11.9846 6.3233L9.52289 8.39997L10.3512 11.3166C10.4096 11.5033 10.3396 11.7016 10.1762 11.8183C10.0829 11.865 9.98956 11.9 9.88456 11.9Z" fill="url(#paint0_linear)"/>
  <defs>
    <linearGradient id="paint0_linear" x1="7.01456" y1="2.11163" x2="7.01456" y2="11.9031" gradientUnits="userSpaceOnUse">
      <stop offset="0.322917" stop-color="#FFD600"/>
      <stop offset="1" stop-color="#FFB72D"/>
    </linearGradient>
  </defs>
</svg>
</template>

<script>
 export default {
   name: 'goldStar'
 }
</script>
